import React from 'react';
import styles from '../../styles/portfolio/short_desc.scss';


export const PersonalWebsite = props => {
    return (
        <div className={styles.description}>
            <div className={styles.containerGeneric}>
                A ReactJS frontend, bundled with Webpack, including code for deployment to AWS Cloudfront Distribution.
                <span className={styles.tagContainer}>Static Website</span>
                <span className={styles.tagContainer}>CDN</span>
            </div>
        </div>
    )
};
